import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DropdownservicesService } from '../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { Inputfiledsbase } from '../../models/inputfiledsbase';
import { TextboxQuestion } from '../../question-textbox';
import { DropdownQuestion } from '../../question-dropdown';

@Injectable({
  providedIn: 'root'
})
export class ComponentserviceService {
  Modeldata: any = [];


  constructor(private dropdownservice: DropdownservicesService) { }

   loadDropdownData(code: string, dataArray: any[] = []) {
      let observable: Observable<any>;
   if (code === 'MODEL') {
        observable = this.dropdownservice.getmodeldrop();
      } else {
        observable = this.dropdownservice.getlookupcodesdropdown(code);
      }

      observable.subscribe((res) => {
        const tempData: any[] = [];
  
        for (let i = 0; i < res?.length; i++) {
          let lookupname;
          if (code === 'MODEL') {
            lookupname = res[i]?.name;
          } 
          if (lookupname != null) {
          tempData.push({
            id: res[i].id,
            key: lookupname,
            value: res[i].id,
          });
        }

        }

        // Replace the old array completely (prevent duplicates)
        dataArray.length = 0;
        dataArray.push(...tempData);
      });
    }

   getcomponentform() {
      this.loadDropdownData('MODEL', this.Modeldata);
  
      const questions: Inputfiledsbase<string>[] = [
         new TextboxQuestion({
          key: 'component_name',
          label: 'Component Name',
          required: true,
          order: 1,
        }),
        new DropdownQuestion({
          key: 'model_id',
          label: 'Select Component',
          options: this.Modeldata,
          required: true,
          order: 2,
        }), 
      ];
  
      return of(questions.sort((a, b) => a.order - b.order));
    }
}
